import "./Utils/api";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Store/store";
import BrandProvider from "./Components/BrandProvider";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <BrandProvider>
          <App />
        </BrandProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
